import Swiper from "swiper";
import {Navigation, Pagination} from 'swiper/modules';

export const initComplexHeader = () => {
	const slider = document.querySelector( 'section.cds2-complex-header-slideshow div.new-slider' );
	
	if ( !slider )
	{
		return;
	}

	const bookmarks = slider.querySelector( 'ul.bookmarks' );
	const btnNext = slider.querySelector( '.swiper-button-next' );
	const btnPrev = slider.querySelector( '.swiper-button-prev' );

	const swiper = new Swiper( slider, {
		slidesPerView: 'auto',
		loop: true,
		modules: [Navigation, Pagination],
		navigation: {
			disabledClass: 'disabled',
			nextEl: btnNext,
			prevEl: btnPrev,
		},
		pagination: {
			el: bookmarks,
			clickable: true,
			noSwiping: true,
			bulletActiveClass: 'current',
			renderBullet: function ( index, className ) {
				return `<li class="${className}"></li>`;
			},
		},
	} );
};
